module.exports = __webpack_public_path__ + "img/客户营销服务一体化解决方案.290430f7.jpg";